import React, { useMemo } from 'react';
import Typography from '@material-ui/core/Typography';
import Section from 'components/content/section';
import SurveyQuestionCard from './question-card';
import surveyQuestions from '../../data-shapers/survey-questions';

export default function TeacherFeedbackSection({ tickets, isLoading }) {
  const questions = useMemo(() => surveyQuestions(tickets, 'teacherFeedback'), [
    tickets,
  ]);

  if (isLoading) {
    return (
      <Section title="Post-interaction staff feedback">
        <Typography>
          <em>Loading data...</em>
        </Typography>
      </Section>
    );
  } else if (questions.length === 0) {
    return (
      <Section title="Post-interaction staff feedback">
        <Typography>
          <em>No data to display.</em>
        </Typography>
      </Section>
    );
  }

  return (
    <Section title="Post-interaction staff feedback">
      <Typography paragraph>
        Staff members were asked these questions immediately after helping a
        student at office hours.
      </Typography>

      {questions.map(({ question, responses, key }) => (
        <SurveyQuestionCard
          question={question}
          responses={responses}
          ticketCount={tickets.length}
          key={key}
        />
      ))}
    </Section>
  );
}
